import { IconComponent } from '@wwt/entities/base'
import CustomIcon from '@wwt/shared/assets/icons/outline/custom.svg'
import DollarIcon from '@wwt/shared/assets/icons/outline/dollar.svg'
import ExpirationIcon from '@wwt/shared/assets/icons/outline/expiration.svg'
import SmileIcon from '@wwt/shared/assets/icons/outline/smile.svg'
import TipIcon from '@wwt/shared/assets/icons/outline/tip.svg'
import WarningIcon from '@wwt/shared/assets/icons/outline/warning.svg'

import { TooltipIconType } from '../types/TooltipIconType'

const TooltipIconsMap: Record<TooltipIconType, IconComponent> = {
	[TooltipIconType.WARNING]: WarningIcon,
	[TooltipIconType.EXPIRED]: ExpirationIcon,
	[TooltipIconType.DOLLAR]: DollarIcon,
	[TooltipIconType.EXPIRING]: ExpirationIcon,
	[TooltipIconType.SMILE]: SmileIcon,
	[TooltipIconType.CUSTOM]: CustomIcon,
	[TooltipIconType.DEFAULT]: TipIcon
}

export const getTooltipIcon = (
	tooltipIconType: TooltipIconType
): IconComponent => {
	return (
		TooltipIconsMap[tooltipIconType] ?? TooltipIconsMap[TooltipIconType.DEFAULT]
	)
}
